const rawBackendUrl = process.env.REACT_APP_BACKEND_URL;

const sameOriginBackendUrl = typeof window !== "undefined" ? window.location.origin : "";

export const BACKEND_URL = (rawBackendUrl || sameOriginBackendUrl).replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;

export function resolveImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("http") || url.startsWith("data:")) return url;
  const normalizedPath = url.startsWith("/") ? url : `/${url}`;
  return `${BACKEND_URL}${normalizedPath}`;
}
